var map = {
	"./Boletin_LibroIndice.mp4": "./src/assets/video/Boletin_LibroIndice.mp4",
	"./CambioContrasen-a.mp4": "./src/assets/video/CambioContrasen-a.mp4",
	"./CitasJuzgados.mp4": "./src/assets/video/CitasJuzgados.mp4",
	"./Conoce tu Tribunal.mp4": "./src/assets/video/Conoce tu Tribunal.mp4",
	"./Consulta Expediente.mp4": "./src/assets/video/Consulta Expediente.mp4",
	"./Demanda.mp4": "./src/assets/video/Demanda.mp4",
	"./FirmarCorreo.mp4": "./src/assets/video/FirmarCorreo.mp4",
	"./PROMOCION.mp4": "./src/assets/video/PROMOCION.mp4",
	"./Registro WhatsApp.mp4": "./src/assets/video/Registro WhatsApp.mp4",
	"./Reportes.mp4": "./src/assets/video/Reportes.mp4",
	"./TUTORIAL_USUARIOS Y POST_SOLICITUD_CITAS.mp4": "./src/assets/video/TUTORIAL_USUARIOS Y POST_SOLICITUD_CITAS.mp4",
	"./VideoTraductor.mp4": "./src/assets/video/VideoTraductor.mp4",
	"./envio_demanda_480.mov": "./src/assets/video/envio_demanda_480.mov",
	"./envio_demanda_480.mp4": "./src/assets/video/envio_demanda_480.mp4",
	"./videoAppTribunal.mp4": "./src/assets/video/videoAppTribunal.mp4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/video sync recursive ^\\.\\/.*$";